import React from 'react';
import PropTypes from 'prop-types';
import HomeSection from '../HomeSection';
import BandCatalogCard from '../../../molecules/BandCatalogCard';
import EditorialEmptyState from '../../../molecules/EditorialEmptyState';
import adaptBandToCatalogCard from '../../../../utils/bandCatalogCard';
import { toPublicBandImageUrl } from '../../../../utils/mediaUrl';
import './index.scss';

const withPublicBandMedia = (cardBand) => {
  if (!cardBand) return cardBand;
  return {
    ...cardBand,
    avatarUrl: toPublicBandImageUrl(cardBand.avatarUrl) || cardBand.avatarUrl,
    imageUrl: toPublicBandImageUrl(cardBand.imageUrl) || cardBand.imageUrl,
  };
};

export default function HomeBandsSection({
  id = 'bands',
  eyebrow,
  title,
  side,
  showSide = false,
  bands = [],
  currentUserId,
  ownerLabel,
  onSelectBand,
  emptyTitle,
  emptyDescription,
  publicMedia = false,
}) {
  if (!bands || bands.length === 0) {
    return (
      <HomeSection
        id={id}
        eyebrow={eyebrow}
        title={title}
        side={side}
        showSide={showSide}
        variant="warm"
      >
        <EditorialEmptyState title={emptyTitle} description={emptyDescription} />
      </HomeSection>
    );
  }

  return (
    <HomeSection
      id={id}
      eyebrow={eyebrow}
      title={title}
      side={side}
      showSide={showSide}
      variant="warm"
      className="home-bands"
    >
      <div className="home-bands__grid">
        {bands.map((band, i) => {
          const isOwner = band.currentUserIsOwner === true
            || (band.ownerId && currentUserId && String(band.ownerId) === String(currentUserId));
          const cardBand = adaptBandToCatalogCard({
            ...band,
            currentUserIsOwner: isOwner,
          });
          const displayBand = publicMedia ? withPublicBandMedia(cardBand) : cardBand;
          if (!displayBand) return null;

          return (
            <BandCatalogCard
              key={displayBand.id || i}
              band={displayBand}
              ownerLabel={ownerLabel}
              onOpen={onSelectBand ? () => onSelectBand(band) : undefined}
            />
          );
        })}
      </div>
    </HomeSection>
  );
}

HomeBandsSection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  side: PropTypes.node,
  showSide: PropTypes.bool,
  bands: PropTypes.array,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ownerLabel: PropTypes.string,
  onSelectBand: PropTypes.func,
  emptyTitle: PropTypes.node,
  emptyDescription: PropTypes.node,
  publicMedia: PropTypes.bool,
};
